module.exports = __webpack_public_path__ + "img/img_yz_produce@3x.2c67dd91.png";